var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTier2Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M20.1523 0.188339C20.5472 0.100613 20.8994 0.452838 20.8117 0.847678L18.6937 10.3801C18.6762 10.4591 18.6762 10.5409 18.6937 10.6199L20.8117 20.1523C20.8994 20.5472 20.5472 20.8994 20.1523 20.8117L10.6199 18.6937C10.5409 18.6762 10.4591 18.6762 10.3801 18.6937L0.847678 20.8117C0.452838 20.8994 0.100613 20.5472 0.188339 20.1523L2.30629 10.6199C2.32383 10.5409 2.32383 10.4591 2.30629 10.3801L0.188339 0.847678C0.100613 0.452838 0.452838 0.100613 0.847678 0.188339L10.3801 2.30629C10.4591 2.32383 10.5409 2.32383 10.6199 2.30629L20.1523 0.188339Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "changeBg",
    d: "M10.505 4.9873L13.2019 7.81791L16.0325 10.5148L13.2019 13.2117L10.505 16.0423L7.80814 13.2117L4.97754 10.5148L7.80814 7.81791L10.505 4.9873Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "changeFill",
    d: "M10.6418 4.92322C10.5999 4.78214 10.4001 4.78214 10.3583 4.92322L8.86307 9.96403L6.68024 15.5437C6.62558 15.6835 6.78975 15.8064 6.90843 15.7145L10.4095 13.0056C10.4628 12.9644 10.5372 12.9644 10.5905 13.0056L14.0916 15.7145C14.2103 15.8064 14.3744 15.6835 14.3198 15.5437L12.1369 9.96403L10.6418 4.92322Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "changeStroke",
    d: "M7.25684 11.3877L5.71308 14.7747",
    stroke: "",
    strokeWidth: 0.552632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTier2Icon);
export default __webpack_public_path__ + "static/media/tier-2-icon.a4a8ba44e38f3315adbc3e09d75463ce.svg";
export { ForwardRef as ReactComponent };